// extracted by mini-css-extract-plugin
module.exports = {"root":"ResendCountdown_root__T95FS","ring":"ResendCountdown_ring__tMYEt","track":"ResendCountdown_track__CHwSU","arc":"ResendCountdown_arc__oXveQ"};